export default __webpack_public_path__ + "static/media/ZingImage.3065ed73.png";